<template>
  <div class="statistics-container">
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>采购汇总表</span>
      </div>
    </div>

    <div class="search-area">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="结算开始日期"
        end-placeholder="结算结束日期"
        value-format="yyyy-MM-dd"
        class="search-input date-picker"
      ></el-date-picker>
      <el-select
        v-model="selectedSupplierNames"
        multiple
        filterable
        placeholder="供应商（多选）"
        class="search-input select-multi"
        clearable
      >
        <el-option
          v-for="item in supplierNameOptions"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
      <el-select
        v-model="selectedContractNames"
        multiple
        filterable
        placeholder="合同名称（多选）"
        class="search-input select-multi"
        clearable
      >
        <el-option
          v-for="item in contractNameOptions"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
      <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
      <el-button v-permission="'statistics:settlement-purchase:export'" type="warning" @click="handleExport" icon="el-icon-download" :loading="exportLoading">导出</el-button>
    </div>

    <div class="table-area">
      <el-table
        :data="tableData"
        border
        stripe
        show-summary
        :summary-method="summaryMethod"
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column prop="supplierUnitName" label="供应商" min-width="130" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="contractNames" label="合同名称" min-width="160" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="settlementCount" label="结算单数量" width="110" align="center">
          <template slot-scope="scope">
            {{ scope.row.settlementCount != null ? scope.row.settlementCount : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="purchaseAmount" label="采购金额" min-width="100" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.purchaseAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="settlementAmount" label="结算金额" min-width="100" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.settlementAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="goToDetail(scope.row)">查看明细</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper, sizes, total"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'SettlementPurchaseSummary',
  data() {
    return {
      dateRange: [],
      selectedSupplierNames: [],
      selectedContractNames: [],
      supplierNameOptions: [],
      contractNameOptions: [],
      loading: false,
      exportLoading: false,
      tableData: [],
      summaryTotals: null,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  created() {
    this.loadFilterOptions()
    this.loadData()
  },
  methods: {
    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleReset() {
      this.dateRange = []
      this.selectedSupplierNames = []
      this.selectedContractNames = []
      this.pagination.currentPage = 1
      this.loadData()
    },
    loadFilterOptions() {
      api.statistics.getSettlementPurchaseSummaryFilterOptions()
        .then(response => {
          if (response.data && response.data.success) {
            const options = response.data.data || {}
            this.supplierNameOptions = options.supplierUnitNames || []
            this.contractNameOptions = options.contractNames || []
          }
        })
        .catch(() => {})
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },
    handleExport() {
      this.exportLoading = true
      const params = {}
      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = this.dateRange[0]
        params.endDate = this.dateRange[1]
      }
      if (this.selectedSupplierNames && this.selectedSupplierNames.length > 0) {
        params.supplierUnitNames = this.selectedSupplierNames
      }
      if (this.selectedContractNames && this.selectedContractNames.length > 0) {
        params.contractNames = this.selectedContractNames
      }
      api.statistics.exportSettlementPurchaseSummaryAggregated(params)
        .then(response => {
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDisposition = response.headers['content-disposition']
          let fileName = '采购汇总表_按供应商.xlsx'
          if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?=([^;]+)/i)
            if (match) {
              fileName = decodeURIComponent(match[1].replace(/^UTF-8''/, '').trim())
            }
          }
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          this.$message.success('导出成功')
        })
        .catch(err => {
          this.$message.error(err.response?.data?.message || '导出失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    formatAmount(amount) {
      if (amount === undefined || amount === null) return '0.00'
      return Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    summaryMethod() {
      const totals = this.summaryTotals || {}
      return [
        '合计',
        '',
        totals.settlementCountSum != null ? Number(totals.settlementCountSum) : 0,
        this.formatAmount(totals.purchaseAmountSum),
        this.formatAmount(totals.settlementAmountSum),
        ''
      ]
    },
    loadData() {
      this.loading = true
      const params = {
        page: this.pagination.currentPage - 1,
        size: this.pagination.pageSize
      }
      if (this.dateRange && this.dateRange.length === 2) {
        params.startDate = this.dateRange[0]
        params.endDate = this.dateRange[1]
      }
      if (this.selectedSupplierNames && this.selectedSupplierNames.length > 0) {
        params.supplierUnitNames = this.selectedSupplierNames
      }
      if (this.selectedContractNames && this.selectedContractNames.length > 0) {
        params.contractNames = this.selectedContractNames
      }
      api.statistics.getSettlementPurchaseSummaryAggregated(params)
        .then(response => {
          if (response.data && response.data.success) {
            const data = response.data.data || {}
            this.tableData = data.content || []
            this.pagination.total = data.totalElements || 0
            this.summaryTotals = data.totals || null
          } else {
            this.tableData = []
            this.summaryTotals = null
            this.$message.error(response.data?.message || '获取采购汇总表失败')
          }
        })
        .catch(err => {
          this.tableData = []
          this.summaryTotals = null
          this.$message.error(err.response?.data?.message || '获取采购汇总表失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    goToDetail(row) {
      const query = {
        scopeSupplierName: row.supplierUnitName,
        startDate: (this.dateRange && this.dateRange[0]) || '',
        endDate: (this.dateRange && this.dateRange[1]) || '',
        spFj: encodeURIComponent(JSON.stringify(this.selectedSupplierNames || [])),
        cnFj: encodeURIComponent(JSON.stringify(this.selectedContractNames || []))
      }
      this.$router.push({ name: 'SettlementPurchaseSummaryDetail', query })
    }
  }
}
</script>

<style lang="scss" scoped>
.statistics-container {
  padding: 20px;
}
.page-header {
  margin-bottom: 20px;
}
.header-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}
.title-mark {
  width: 4px;
  height: 18px;
  background: #409eff;
  margin-right: 10px;
}
.search-area {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.search-input {
  width: 200px;
}
.select-multi {
  min-width: 200px;
  max-width: 280px;
}
.date-picker {
  width: 300px;
}
.table-area {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
::v-deep .el-table th {
  background-color: #f5f7fa !important;
  color: #606266 !important;
  font-weight: 600;
}
::v-deep .el-table__footer-wrapper tbody td {
  background-color: #fafafa !important;
  font-weight: 600;
}
</style>
